/**
 * hashes constants
 */
const SET_HASH = 'SET_HASH';
export default SET_HASH;
